import { render, staticRenderFns } from "./selectLabel.vue?vue&type=template&id=d67a8696&scoped=true&"
import script from "./selectLabel.vue?vue&type=script&lang=js&"
export * from "./selectLabel.vue?vue&type=script&lang=js&"
import style0 from "./selectLabel.vue?vue&type=style&index=0&id=d67a8696&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d67a8696",
  null
  
)

export default component.exports